import type { FC, ReactNode } from "react";

import { Box } from "@hightouch/htui";

import { PrivateContext } from "src/components/private-context";

// Wrap any PII to avoid sending to LogRocket
export const Private: FC<{ children: ReactNode; isDisabled?: boolean }> = ({
  children,
  isDisabled = false,
}) =>
  isDisabled ? (
    <>{children}</>
  ) : (
    <PrivateContext.Provider value={true}>
      <Box display="contents" data-private>
        {children}
      </Box>
    </PrivateContext.Provider>
  );
